/**
 * @generated SignedSource<<fc535563c86e22501e1c93263e7ed1f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditClozeTextElementV2Input = {
  additionalWords: ReadonlyArray<string>;
  clientMutationId?: string | null;
  clozeTextElementId: string;
  text: string;
  title: string;
};
export type ClozeTextElementForm_EditClozeTextElementMutation$variables = {
  input: EditClozeTextElementV2Input;
};
export type ClozeTextElementForm_EditClozeTextElementMutation$data = {
  readonly Admin: {
    readonly ElearningV2: {
      readonly editClozeTextElement: {
        readonly clozeTextElement: {
          readonly " $fragmentSpreads": FragmentRefs<"ClozeTextElementForm_ClozeTextElementFragment">;
        };
      } | null;
    };
  };
};
export type ClozeTextElementForm_EditClozeTextElementMutation = {
  response: ClozeTextElementForm_EditClozeTextElementMutation$data;
  variables: ClozeTextElementForm_EditClozeTextElementMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClozeTextElementForm_EditClozeTextElementMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElearningV2AdminMutationSchema",
            "kind": "LinkedField",
            "name": "ElearningV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditClozeTextElementV2Payload",
                "kind": "LinkedField",
                "name": "editClozeTextElement",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClozeTextElementV2",
                    "kind": "LinkedField",
                    "name": "clozeTextElement",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ClozeTextElementForm_ClozeTextElementFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClozeTextElementForm_EditClozeTextElementMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElearningV2AdminMutationSchema",
            "kind": "LinkedField",
            "name": "ElearningV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditClozeTextElementV2Payload",
                "kind": "LinkedField",
                "name": "editClozeTextElement",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClozeTextElementV2",
                    "kind": "LinkedField",
                    "name": "clozeTextElement",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "text",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "additionalWords",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4e828bc038ab19450b9faf8b69ff2f00",
    "id": null,
    "metadata": {},
    "name": "ClozeTextElementForm_EditClozeTextElementMutation",
    "operationKind": "mutation",
    "text": "mutation ClozeTextElementForm_EditClozeTextElementMutation(\n  $input: EditClozeTextElementV2Input!\n) {\n  Admin {\n    ElearningV2 {\n      editClozeTextElement(input: $input) {\n        clozeTextElement {\n          ...ClozeTextElementForm_ClozeTextElementFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment ClozeTextElementForm_ClozeTextElementFragment on ClozeTextElementV2 {\n  id\n  title\n  text\n  additionalWords\n}\n"
  }
};
})();

(node as any).hash = "4226e441e6475ebcf20689474db1a740";

export default node;
